import styled, { css } from 'styled-components';

export const StyledToolbarContainer = styled.div<{
  isPreviewAction?: boolean;
  inIsland?: boolean;
  highPriority?: boolean;
}>`
  position: fixed;
  display: flex;
  padding: var(--cl-space-2) var(--cl-space-3);
  background: rgb(251 244 211 / 90%);
  border-radius: var(--cl-radius-2);
  bottom: ${({ isPreviewAction }) => (isPreviewAction ? 'var(--cl-space-16)' : 'var(--cl-space-3)')};
  left: var(--cl-space-7);

  justify-content: space-between;
  font-family: var(--cl-font-family-default);
  gap: var(--cl-space-4);
  backdrop-filter: blur(2px);
  box-shadow: 0 2px var(--cl-space-2) 1px var(--cl-gray-500);

  ${({ inIsland }) => (inIsland && css`
    flex-direction: column;
    margin-right: var(--cl-space-4);
    margin-bottom: var(--cl-space-4);
    position: relative;
    bottom: auto;
    left: var(--cl-space-10);
    margin-top: var(--cl-space-2);
    width: calc(100% - var(--cl-space-2) - var(--cl-space-3) - var(--cl-space-10));
  `)}

  ${({ highPriority }) => (highPriority && css`
    background: rgb(254 226 227 / 90%);
    box-shadow: 0 0px 2px var(--cl-red-100);
  `)}
`;

export const StyledToolbarMessage = styled.div`
  display: flex;
  gap: var(--cl-space-1);
  align-items: center;

  svg {
    flex-shrink: 0;
  }
`;
